export const SEARCH_KEYWORD_VIEW_MODE = 'search-keyword-view-mode'
export const SEARCH_AUTO_COMPLETE_KEYWORD_LIST_INFO = 'search-auto-complete-keyword-list'
export const SEARCH_BY_TAG = 'search-by-tag'
export const SEARCH_EDITORPICK = 'search-editorpick'
